import React from 'react';
import { Evidence } from '@eas/common-web';
import { useEsFiles } from '../es-file/es-files';
import { useColumns } from './all-es-files-columns';

export const ALL_ES_FILES_VERSION = 16;
export const ALL_ES_FILES_IDENTIFIER = 'ALL_ES_FILES';

export function AllEsFiles() {
  const columns = useColumns();

  const { evidenceBag } = useEsFiles({
    evidenceProps: {
      identifier: ALL_ES_FILES_IDENTIFIER,
      version: ALL_ES_FILES_VERSION,
      tableProps: { columns: columns },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => btn !== 'NEW',
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
